import type { DoNotBuyStatus } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateDoNotBuyMutationAtom = createMutationAtomFactory(
  'settings.doNotBuyEntryUpdate',
  (params: {
    id: string;
    reason?: string;
    status?: DoNotBuyStatus;
    effectiveTo?: string;
    notes?: string;
  }) => ({
    complianceDoNotBuyEntryUpdate: {
      __args: {
        id: params.id,
        input: {
          reason: params.reason,
          status: params.status,
          effectiveTo: params.effectiveTo,
          notes: params.notes,
        },
      },
      id: true,
    },
  }),
);
